export const layoutEvents = {
    headerClick: {
        event: 'nav_click',
        nav_section: 'header nav',
    },
    headerMenuNavClick: {
        event: 'nav_click',
        nav_section: 'main nav',
    },
    footerClick: {
        event: 'nav_click',
        nav_section: 'footer nav',
    },
};
